import { z } from 'zod';
import { metadata } from './helpers';
import { contentBase } from './content';

export const footerSchema = z.object({
  metadata: metadata,
  data: z.object({
    footerBackgroundImage: z.string(),
    footerPhrase: z.string(),
    showClaimSectionsLinks: z.boolean(),
    claimSectionsTitle: z.string(),
    showLinks: z.boolean(),
    linksTitle: z.string(),
    links: z.array(
      z.object({
        label: z.string(),
        href: z.string(),
        badge: z.string().optional().nullable(),
      })
    ),
    showLocations: z.boolean(),
    locationsTitle: z.string(),
    selectedOfficeIds: z.array(z.string()),
    showContacts: z.boolean(),
    contactsTitle: z.string(),
    showSocial: z.boolean(),
    defaultFormId: z.number().int().positive(),
  }),
});

export const contentTypeFooterSchema = contentBase.extend({
  content: footerSchema,
  is_default: z.boolean().optional(),
  claim_section_id: z.number().int().positive().nullish(),
});

export type ContentTypeFooterContentInput = z.infer<typeof contentTypeFooterSchema>;
